import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from '@components/layouts/error/error.component';
import { ConvenioResolver } from '@resolvers/convenio.resolver';
import { EmitirSuscripcionResolver } from '@resolvers/emitir-suscripcion.resolver';
import { ExitoGuard } from '@guards/exito.guard';
import { LandingResolver } from '@resolvers/landing.resolver';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./containers/public/public.module').then((m) => m.PublicModule),
    resolve: {
      convenio: ConvenioResolver,
    },
  },
  {
    path: 'landing',
    loadChildren: () =>
      import('./containers/landing/landing.module').then(
        (m) => m.LandingModule
      ),
    resolve: {
      convenio: ConvenioResolver,
      landing: LandingResolver,
    },
  },
  {
    path: 'exito',
    loadChildren: () =>
      import('./components/layouts/exito/exito.module').then(
        (m) => m.ExitoModule
      ),
    data: {
      title: 'Exito | Seguro Automotriz | Zenit Seguros',
    },
    canActivate: [ExitoGuard],
    resolve: {
      emitirSuscripcion: EmitirSuscripcionResolver,
    },
  },
  {
    path: 'error',
    component: ErrorComponent,
    data: {
      title: 'Error | Seguro Automotriz | Zenit Seguros',
    },
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/error',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
